
// Fix nav active state - only highlight the exact current page
(function() {
  // Inject override style AFTER all theme styles to beat .header * rule
  var styleEl = document.createElement('style');
  styleEl.id = 'nav-active-override';
  styleEl.textContent = [
    '.header .menu__link.menu__link-lv1.nav-active-exact,',
    '.header .menu__link.menu__link-lv1.nav-active-exact .link__title,',
    '.header .nav-active-exact.menu__link-lv1,',
    '.header .nav-active-exact .link__title,',
    '.header *.nav-active-exact,',
    '.header * .nav-active-exact-child {',
    '  color: #00B140 !important;',
    '  text-shadow: 0 0 6px rgba(0,177,64,0.4) !important;',
    '}'
  ].join('\n');
  document.head.appendChild(styleEl);

  document.addEventListener('DOMContentLoaded', function() {
    var path = window.location.pathname;
    var search = window.location.search;
    var fullUrl = path + search;
    
    var lv1Links = document.querySelectorAll('.menu__link-lv1');
    
    lv1Links.forEach(function(link) {
      link.classList.remove('menu__link--active');
      
      var href = link.getAttribute('href') || '';
      var hrefPath = href.split('?')[0];
      var hrefSearch = href.indexOf('?') >= 0 ? href.substring(href.indexOf('?')) : '';
      
      var isMatch = false;
      
      if (href === fullUrl) {
        isMatch = true;
      } else if (!hrefSearch && hrefPath === path && !search) {
        isMatch = true;
      } else if (href === '/' && path === '/') {
        isMatch = true;
      } else if (hrefSearch && hrefPath === path && hrefSearch === search) {
        isMatch = true;
      }
      
      if (isMatch) {
        link.classList.add('nav-active-exact');
        // Also mark the inner title span
        var titleSpan = link.querySelector('.link__title');
        if (titleSpan) {
          titleSpan.classList.add('nav-active-exact-child');
        }
      }
    });
    


    // Hide Best Sellers nav link (temporary)
    lv1Links.forEach(function(link) {
      var titleEl = link.querySelector('.link__title');
      var txt = (titleEl ? titleEl.textContent : link.textContent).trim().toLowerCase();
      if (txt === 'best sellers') {
        var li = link.closest('li') || link.parentElement;
        if (li) li.style.display = 'none';
      }
    });
    // Move our style to the very end of head to ensure it wins
    var override = document.getElementById('nav-active-override');
    if (override) {
      document.head.appendChild(override);
    }
  });
})();
